<div class="report-controls" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;padding:16px;">
  <mat-form-field appearance="outline">
    <mat-label>Centre</mat-label>
    <mat-select [formControl]="centreControl">
      <mat-option value="All">All</mat-option>
      <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">{{ c.centreName }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Date range</mat-label>
    <mat-date-range-input [rangePicker]="rangePicker">
      <input matStartDate placeholder="Start date" [formControl]="startDateControl">
      <input matEndDate placeholder="End date" [formControl]="endDateControl">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #rangePicker></mat-date-range-picker>
  </mat-form-field>

  <button mat-mini-fab color="primary" (click)="search()" [disabled]="loading" matTooltip="Search">
    <mat-icon>search</mat-icon>
  </button>

  <button mat-mini-fab color="accent" (click)="clearFilters()" matTooltip="Clear Filters">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<!-- Table 1: Children 4-14 years -->
<div class="card" style="margin-bottom: 24px;">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Highlighted Education Sessions - Children (4-14 years)</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input-1"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" id="search-input-1" type="text" class="browser-default search-field"
               (keyup)='applyFilter1($event)' aria-label="Search box">
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSource4to14" class="mat-elevation-z8" matSort #sort1="matSort" *ngIf="!loading && dataSource4to14.data.length">

    <!-- Child Name Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name </th>
      <td mat-cell *matCellDef="let row"> {{row.childName || 'N/A'}} </td>
    </ng-container>

    <!-- Session Type Column -->
    <ng-container matColumnDef="sessionType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type </th>
      <td mat-cell *matCellDef="let row"> {{row.type || 'N/A'}} </td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
      <td mat-cell *matCellDef="let row"> {{formatDate(row.date)}} </td>
    </ng-container>

    <!-- Topic Column -->
    <ng-container matColumnDef="topic">
      <th mat-header-cell *matHeaderCellDef> Topic </th>
      <td mat-cell *matCellDef="let row"> {{row.topic || 'N/A'}} </td>
    </ng-container>

    <!-- Submitted By Column -->
    <ng-container matColumnDef="submittedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted By </th>
      <td mat-cell *matCellDef="let row"> {{row.submittedBy || 'N/A'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let _row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator1 [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons></mat-paginator>

  <div *ngIf="!loading && !dataSource4to14.data.length" style="padding: 20px; text-align: center;">
    No highlighted sessions found for children aged 4-14 years.
  </div>
</div>

<!-- Table 2: Children 14-18 years -->
<div class="card" style="margin-bottom: 24px;">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Highlighted Education Sessions - Adolescents (14-18 years)</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input-2"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" id="search-input-2" type="text" class="browser-default search-field"
               (keyup)='applyFilter2($event)' aria-label="Search box">
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSource14to18" class="mat-elevation-z8" matSort #sort2="matSort" *ngIf="!loading && dataSource14to18.data.length">

    <!-- Child Name Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name </th>
      <td mat-cell *matCellDef="let row"> {{row.childName || 'N/A'}} </td>
    </ng-container>

    <!-- Session Type Column -->
    <ng-container matColumnDef="sessionType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type </th>
      <td mat-cell *matCellDef="let row"> {{row.type || 'N/A'}} </td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
      <td mat-cell *matCellDef="let row"> {{formatDate(row.date)}} </td>
    </ng-container>

    <!-- Topic Column -->
    <ng-container matColumnDef="topic">
      <th mat-header-cell *matHeaderCellDef> Topic </th>
      <td mat-cell *matCellDef="let row"> {{row.topic || 'N/A'}} </td>
    </ng-container>

    <!-- Submitted By Column -->
    <ng-container matColumnDef="submittedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted By </th>
      <td mat-cell *matCellDef="let row"> {{row.submittedBy || 'N/A'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let _row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator2 [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons></mat-paginator>

  <div *ngIf="!loading && !dataSource14to18.data.length" style="padding: 20px; text-align: center;">
    No highlighted sessions found for adolescents aged 14-18 years.
  </div>
</div>

<!-- Table 3: Follow-up Sessions -->
<div class="card">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Highlighted Education Sessions - Follow-up</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input-3"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" id="search-input-3" type="text" class="browser-default search-field"
               (keyup)='applyFilter3($event)' aria-label="Search box">
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSourceFollowUp" class="mat-elevation-z8" matSort #sort3="matSort" *ngIf="!loading && dataSourceFollowUp.data.length">

    <!-- Child Name Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name </th>
      <td mat-cell *matCellDef="let row"> {{row.childName || 'N/A'}} </td>
    </ng-container>

    <!-- Session Type Column -->
    <ng-container matColumnDef="sessionType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type </th>
      <td mat-cell *matCellDef="let row"> {{row.type || 'N/A'}} </td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
      <td mat-cell *matCellDef="let row"> {{formatDate(row.date)}} </td>
    </ng-container>

    <!-- Topic Column -->
    <ng-container matColumnDef="topic">
      <th mat-header-cell *matHeaderCellDef> Topic </th>
      <td mat-cell *matCellDef="let row"> {{row.topic || 'N/A'}} </td>
    </ng-container>

    <!-- Submitted By Column -->
    <ng-container matColumnDef="submittedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted By </th>
      <td mat-cell *matCellDef="let row"> {{row.submittedBy || 'N/A'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let _row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator3 [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons></mat-paginator>

  <div *ngIf="!loading && !dataSourceFollowUp.data.length" style="padding: 20px; text-align: center;">
    No highlighted follow-up sessions found.
  </div>
</div>

<div *ngIf="!loading && !dataSource4to14.data.length && !dataSource14to18.data.length && !dataSourceFollowUp.data.length" style="padding: 20px; text-align: center; margin-top: 20px;">
  <p>No highlighted sessions found. Select filters and click Search.</p>
</div>

